import {AppointmentResponse} from '@/api/MLSChallenge/useGetPlayerAppointments';

export const getScoreProgress = (
  sessionSummariesWithScore: AppointmentResponse['sessionSummaries']['summaries']
): string => {
  const now = new Date();
  const oneMonthAgo = new Date(now);
  oneMonthAgo.setMonth(now.getMonth() - 1);

  // Filter sessions within the last month
  const sessionsInLastMonth = sessionSummariesWithScore.filter((s) => {
    const sessionDate = new Date(s.startDateTime);
    return sessionDate >= oneMonthAgo && sessionDate <= now;
  });

  if (sessionsInLastMonth.length < 2) {
    return 'No score change in the past month.';
  }

  // First and last session within the last month (by date)
  const sortedSessions = [...sessionsInLastMonth].sort(
    (a, b) => new Date(a.startDateTime).getTime() - new Date(b.startDateTime).getTime()
  );
  const firstSession = sortedSessions[0];
  const lastSession = sortedSessions[sortedSessions.length - 1];

  const firstScore = Math.round(firstSession.summary.session.tocaScore || 0);
  const lastScore = Math.round(lastSession.summary.session.tocaScore || 0);
  const scoreProgress = lastScore - firstScore;

  return `Your score has a ${scoreProgress >= 0 ? '+' : ''}${scoreProgress} Maturity over the past month.`;
};

export const getDisplayData = (sessionSummaries: AppointmentResponse['sessionSummaries']['summaries']) => {
  return sessionSummaries
    .slice()
    .reverse()
    .map((session) => {
      const sessionDate = new Date(session?.startDateTime);
      const formattedDate = sessionDate.toLocaleDateString('en-US', {
        month: '2-digit',
        day: '2-digit',
        year: '2-digit',
      });
      const tocaScore = Math.round(session.summary.session.tocaScore || 0);
      return {
        tocaScore,
        date: formattedDate,
        isBaselineSession: session.isBaselineSession,
        sessionId: session._id,
      };
    });
};
